<div class="data-table-container">
  <table class="min-w-full">
    <caption class="visually-hidden">{{ caption }}</caption>
    <thead class="border-b">
      <tr>
        <ng-container
          *ngTemplateOutlet="headers; context: { $implicit: data }"
        ></ng-container>
      </tr>
    </thead>
    <tbody *ngIf="data | async as rowsData">
      <tr *ngIf="loading">
        <td [attr.colspan]="columnCount" role="status">Loading…</td>
      </tr>
      <tr *ngIf="!loading && !rowsData.length">
        <td [attr.colspan]="columnCount">{{ emptyMessage }}</td>
      </tr>
      <tr *ngFor="let row of rowsData" class="border-b">
        <ng-container
          *ngTemplateOutlet="rows; context: { $implicit: row }"
        ></ng-container>
      </tr>
    </tbody>
  </table>
</div>
